import ApplicationComponent from "legacy/ApplicationComponent"
import StripeElement from "legacy/credit-cards/StripeElement"
import { paymentMethodDisplayText } from "legacy/helpers.es6"
import PropTypes from "prop-types"
import React from "react"

class SelectOrAddCard extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.state = {
      selectionType: this.hasUserCards() ? "existingCard" : "newCard",
      selectedCardId: this.hasUserCards() ? this.props.userCards[0] : null,
    }
    this.stripeElementRef = React.createRef()
    this.getCardAndType = this.getCardAndType.bind(this)
  }

  getCardAndType() {
    if (this.isExistingCardSelector()) {
      this.props.successCallback({
        type: "existing",
        id: this.state.selectedCardId,
      })
    } else {
      this.stripeElementRef.current.createStripePaymentMethod()
    }
  }

  hasUserCards() {
    return this.props.userCards.length > 0
  }

  isExistingCardSelector() {
    return this.state.selectionType === "existingCard"
  }

  isNewCardSelector() {
    return this.state.selectionType === "newCard"
  }

  renderSelectorType() {
    if (!this.hasUserCards()) return null

    return (
      <div>
        <div className="radio">
          <label>
            <input
              type="radio"
              name="selectionType"
              value="existingCard"
              checked={this.isExistingCardSelector()}
              onChange={this.handleInputChange}
            />
            Select an existing card
          </label>
        </div>
        <div className="radio">
          <label>
            <input
              type="radio"
              name="selectionType"
              value="newCard"
              checked={this.isNewCardSelector()}
              onChange={this.handleInputChange}
            />
            Add a new card
          </label>
        </div>
      </div>
    )
  }

  renderCardSelector() {
    if (this.isNewCardSelector()) return null

    return (
      <div className="form-group">
        <select
          className="form-control"
          value={this.state.selectedCardId}
          name="selectedCardId"
          onChange={this.handleInputChange}
        >
          {this.props.userCards.map((paymentMethod) => {
            return (
              <option
                key={paymentMethod.id}
                value={paymentMethod.stripePaymentMethodId}
              >
                {paymentMethodDisplayText(paymentMethod)}
              </option>
            )
          })}
        </select>
      </div>
    )
  }

  renderSddCard() {
    if (this.isExistingCardSelector()) return null

    return (
      <StripeElement
        ref={this.stripeElementRef}
        successCallback={(response) =>
          this.props.successCallback({ type: "new", id: response.id })
        }
        errorCallback={this.props.cardError}
      />
    )
  }

  render() {
    return (
      <div>
        {this.renderSelectorType()}
        {this.renderCardSelector()}
        {this.renderSddCard()}
      </div>
    )
  }
}

SelectOrAddCard.propTypes = {
  userCards: PropTypes.array.isRequired,
  successCallback: PropTypes.func.isRequired,
  cardError: PropTypes.func,
}

export default SelectOrAddCard
